import { getSearch } from './core/getSearch';

export const Services = {
  core: {
    getSearch,
  },
};
